import React, { createContext, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAPI } from './authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Inicializamos el estado leyendo de sessionStorage para mantener la sesión
  const [token, setToken] = useState(sessionStorage.getItem('jwtToken'));
  const [isAuthenticated, setIsAuthenticated] = useState(!!sessionStorage.getItem('jwtToken'));
  const navigate = useNavigate();

  const login = async (username, password) => {
    try {
      const receivedToken = await loginAPI(username, password);
      sessionStorage.setItem('jwtToken', receivedToken);
      setToken(receivedToken);
      setIsAuthenticated(true);
      navigate('/main'); // Navega a la página principal tras un login exitoso
      return { success: true };
    } catch (error) {
      console.error('Fallo el inicio de sesión:', error);
      logout(false); // Limpiamos el estado en caso de fallo
      return { success: false, error: error.message };
    }
  };

  const logout = (shouldNavigate = true) => {
    sessionStorage.removeItem('jwtToken');
    setToken(null);
    setIsAuthenticated(false);
    if (shouldNavigate) {
      navigate('/login'); // Navega a la página de login al cerrar sesión
    }
  };

  const value = { token, isAuthenticated, login, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  return context;
};